import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { BR_DATE_FORMATS } from './core/config/date-formats';
import { reloadOnStaleChunk } from './core/config/chunk-reload';

import { provideNgxMask } from 'ngx-mask';
import { SocialAuthService, SocialAuthServiceConfig, GoogleLoginProvider, SOCIAL_AUTH_CONFIG, SocialLoginModule } from '@abacritt/angularx-social-login';
import { importProvidersFrom } from '@angular/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withNavigationErrorHandler(reloadOnStaleChunk)),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNgxMask(),
    importProvidersFrom(SocialLoginModule),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '886204916681-n24ndgnti2d8vp24ugkld9urq20b5aq7.apps.googleusercontent.com'
            )
          }
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: BR_DATE_FORMATS }
  ]
};
